<div mat-dialog-title class="dialog-header aum-typo-headline-3">
    <div class="dialog-title">{{ titleLocalizationKey | i18next }}</div>

    <div class="close-dialog">
        <mat-dialog-actions>
            <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
        </mat-dialog-actions>
    </div>
</div>

<div mat-dialog-content>
    <div *ngIf="contentMessage != null">
        <quill-editor
            class="text-area"
            placeholder="{{ 'aumico_annual_report_complementary_reports_report_rich_text_placeholder' | i18next }}"
            [formControl]="content"
            [modules]="{ toolbar: [] }"
            [styles]="{
                height: '280px'
            }"
        >
        </quill-editor>
    </div>
</div>

<div class="dialog-footer" (click)="onAddNoteText()">
    <mat-icon svgIcon="aumico_add_icon_black"></mat-icon>
    <div>{{ 'aumico_notes_add_all_text' | i18next }}</div>
</div>
